module.exports = __webpack_public_path__ + "static/media/taffiethule04.c17ac6e7.jpg";